import PotentialWell from "../../../../../assets/PotentialWellRelief.png";
import compliance from "../../../../../assets/compliance.jpg";
import electrical from "../../../../../assets/electrical.jpg";
import plumbing from "../../../../../assets/plumbing.png";
import safety from "../../../../../assets/safety.jpg";
import candgLogo from "../../../../../assets/candg-logo.png";
import cscsLogo from "../../../../../assets/CSCS_text_white.png";
import ecsLogo from "../../../../../assets/ecs-logo.png";
import electricalProLogo from "../../../../../assets/electricalProIdent.png";
import award2018 from "../../../../../assets/award2018.png";
import award2025 from "../../../../../assets/award2025.png";
import award2021 from "../../../../../assets/award2021.png";
import baa from "../../../../../assets/BAA.png";
import gatwick from "../../../../../assets/gatwick.png";
import jaguar from "../../../../../assets/jaguar.png";
import megger from "../../../../../assets/Megger.png";
import mk from "../../../../../assets/MK.png";
import nestle from "../../../../../assets/nestle-updated.png";
import niceic from "../../../../../assets/NIC_EIC.png";
import esfLogo from "../../../../../assets/esf_logo.png";
export var learnCategories = [
    {
        title: "Electrical",
        icon: "fa-bolt",
        description: "For electricians, apprentices and other electro-technical professionals. Courses resources and more...",
        img: electrical,
        items: [
            "wiringRegs",
            "ecs",
            "fess",
            "cscs",
            "electricalPro",
            "sip",
            "eeaw",
            "electricalEquipmentUserChecks",
            "renewables"
        ]
    },
    {
        title: "Plumbing",
        icon: "fa-wrench",
        description: "Essential skills for trainee & apprentice plumbers.",
        img: plumbing,
        items: [
            "plumbingPro",
            "renewables"
        ]
    },
    {
        title: "Corporate Compliance",
        icon: "fa-briefcase",
        description: "For organisations. Courses resources and more...",
        img: compliance,
        items: [
            "corporateCompliance",
            "cohe",
            "wah",
            "fess"
        ]
    },
    {
        title: "Health and Safety",
        icon: "fa-shield-alt",
        description: "For organisations. Courses resources and more...",
        img: safety,
        items: [
            "cohe",
            "wah",
            "eeaw",
            "electricalEquipmentUserChecks",
            "fess"
        ]
    },
];
export var products = [
    {
        id: 'wiringRegs',
        header: "Wiring Regs",
        tagline: "full course | 100% online | learn on-demand | online exam",
        icon: candgLogo,
        link: 'https://www.learninglounge.com/18',
        target: '_blank',
    },
    {
        id: 'cscs',
        header: "CSCS",
        tagline: "construction skills certification scheme",
        icon: cscsLogo,
        link: 'https://www.learninglounge.com/cscs',
    },
    {
        id: 'ecs',
        header: "ECS",
        tagline: "electrical safety essentials",
        icon: ecsLogo,
        link: 'https://ecs.learninglounge.com',
        target: '_blank',
    },
    {
        id: 'ace',
        header: "ACE Electrical",
        tagline: "Essential learning for apprentices, trainees & professionals",
        icon: "./Images/SharedImages/esf_logo.png",
        link: '/en/select/1776350290',
    },
    {
        id: 'electricalPro',
        header: "Electrical Pro",
        tagline: "the trusted online resource for professional electricians",
        icon: electricalProLogo,
        link: 'https://www.learninglounge.com/com/133775463/',
    },
    {
        id: 'sip',
        header: "Safe Isolation Procedures",
        tagline: "compliance training | 100% online | learn on-demand",
        icon: PotentialWell,
        link: 'https://sip.learninglounge.com/',
    },
    {
        id: 'cohe',
        header: "Control of Hazardous Energy",
        tagline: "compliance training | 100% online | learn on-demand",
        icon: PotentialWell,
        link: 'https://cohe.learninglounge.com/',
        target: '_blank'
    },
    {
        id: 'wah',
        header: "Working at height",
        tagline: "compliance training | 100% online | learn on-demand",
        icon: PotentialWell,
        link: 'https://wah.learninglounge.com/'
    },
    {
        id: 'eeaw',
        header: "Electricity at Work",
        tagline: "compliance training | 100% online | learn on-demand",
        icon: PotentialWell,
        link: 'https://eaw.learninglounge.com/',
    },
    {
        id: 'electricalEquipmentUserChecks',
        header: "Electrical Equipment User Checks",
        tagline: "compliance training | 100% online | learn on-demand",
        icon: PotentialWell,
        link: 'https://eeuc.learninglounge.com/'
    },
    {
        id: 'plumbingPro',
        header: "Plumbing Pro",
        tagline: "Essential Theory and Practical Skills for Plumbers",
        icon: PotentialWell,
        link: 'https://www.learninglounge.com/com/258654888/'
    },
    {
        id: 'renewables',
        header: "Renewables",
        tagline: "The Science and Technology of Renewable Resources ",
        icon: PotentialWell,
        link: 'https://www.learninglounge.com/com/1503486760/'
    },
    {
        id: 'corporateCompliance',
        header: "Corporate Compliance",
        tagline: "compliance training | 100% online | learn on-demand",
        icon: PotentialWell,
        link: 'https://www.learninglounge.com/spot/channels/ecp/12345678',
    },
    {
        id: 'fess',
        header: "FESS",
        tagline: "Fire, Emergency and Security Systems",
        icon: PotentialWell,
        link: 'https://fess.learninglounge.com',
    }
];
export var awards = [
    {
        img: award2018,
        link: 'https://www.learninglounge.com/'
    },
    {
        img: award2025,
        link: 'https://www.learninglounge.com/'
    },
    {
        img: award2021,
        link: 'https://www.learninglounge.com/'
    }
];
export var reviews = [
    {
        name: "Jackie Portman",
        stars: 5,
        review: "Incredible training experience - I have been following the IET Wiring Regulations course and everything about this material is superb and brilliantly put together and user friendly. You cannot fail to learn and actually enjoy the process.",
    },
    {
        name: "Chin Nung",
        stars: 5,
        review: "This is my first time participating to the on-line course which gave me a great and unprecedented experience specially for the unlimited schedule, repetative leaning and pre exam tests that I had plenty of preparation before any formal exams. The on-line exam is also an amazing experience and most benefit to me by saving my traffic time and expenses for attending exam centre.",
    },
    {
        name: "Ny",
        stars: 5,
        review: "I would highly recommend. I completed my 18th edition online course with Learning Lounge. It was very informative and not what I was expecting. Flagging up the regs was really helpful and how to get around the book. A good amount of information in the vids and I liked how there where little questions after each section. Customer service was amazing. Great company with great people.",
    },
    {
        name: "Gladstone Brown",
        stars: 5,
        review: "Learning Lounge was very helpful and accommodating. They made me feel at ease, before my Exam. I would definitely do further courses with them. ",
    },
    {
        name: "Colin",
        stars: 5,
        review: "The overall structure of the training course was really good. The course goes into so much depth and gets you ready for the final exam. It can be intense but being able to do it from home at your own pace helps a lot. Also making you get 80% pass mark before you can apply for the formal exam is a masterstroke.",
    },
    {
        name: "Thomas",
        stars: 4,
        review: "When I was ready to attend the exam after scoring above 80% marks in the final mock test, contacted learning lounge. My exam date and time booked in my requested slot. The service provided was absolute brilliant. Thanks James. It was bit hard for me achieve +80% criteria in the mock test to get the certificate. However, this exercise made me confident and achieved 85% in the official online exam.",
    },
];
export var caseStudies = [
    {
        title: "British Airports Authority",
        img: baa,
        link: "https://www.navigatorproductions.com/project-baa.html"
    },
    {
        title: "Electrical Safety First",
        img: esfLogo,
        link: "https://www.navigatorproductions.com/project-esf.html"
    },
    {
        title: "Gatwick Airport",
        img: gatwick,
        link: "https://www.navigatorproductions.com/project-gatwick.html"
    },
    {
        title: "Jaguar Land Rover",
        img: jaguar,
        link: "https://www.navigatorproductions.com/project-jaguar.html"
    },
    {
        title: "Megger",
        img: megger,
        link: "https://www.navigatorproductions.com/project-megger.html"
    },
    {
        title: "MK Electric",
        img: mk,
        link: "https://www.navigatorproductions.com/project-mk.html"
    },
    {
        title: "Nestle",
        img: nestle,
        link: "https://www.navigatorproductions.com/project-nestle.html"
    },
    {
        title: "NICEIC",
        img: niceic,
        link: "https://www.navigatorproductions.com/project-niceic.html"
    },
];
export var faqs = [
    {
        question: "if I take the £50 electrical compliance course, does this make me a fully qualified electrician?",
        answer: "NO"
    },
    {
        question: "Is this the ECS?",
        answer: "<span class='h1 display-1 fw-bold' style='color:#25D366'>NO</span>"
    },
    {
        question: "Should I plug my laptop in for an exam?",
        answer: "YES"
    }
];
